import { Alert } from "reactstrap";
import { useState } from "react";
import { useTranslation } from "react-i18next";
const RegulationAlert = ({
  title,
  description,
  icon,
  iconAlt = "regulation-icon",
  isOpen = true,
  onClose,
  className = "",
}) => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(isOpen);
  const handleClose = () => {
    setIsVisible(false);
    if (onClose) {
      onClose();
    }
  };
  if (!isVisible) {
    return null;
  }
  return (
    <Alert
      className={`bg-white border border-[#d3d3d3] rounded-lg p-4 relative ${className}`}
    >
      <button
        type="button"
        className="absolute top-4 right-4 text-[#5e5e5e] hover:text-[#222222] focus:outline-none transition-colors"
        onClick={handleClose}
        aria-label={t("Close")}
      >
        <i className="fas fa-times text-[14px]" />
      </button>
      <div className="w-full flex items-start gap-4 pr-8">
        {icon && (
          <div className="flex-shrink-0">
            {typeof icon === "string" ? <img src={icon} alt={iconAlt} /> : icon}
          </div>
        )}
        <div className="flex flex-col text-[#222222] flex-1">
          <h3 className="font-extrabold text-[14px] mb-1">{title}</h3>
          <div className="text-[14px] leading-[20px] text-[#5e5e5e]">
            {typeof description === "string"
              ? description.split("\n").map((line, index, array) => (
                  <span key={index}>
                    {line}
                    {index < array.length - 1 && <br />}
                  </span>
                ))
              : description}
          </div>
        </div>
      </div>
    </Alert>
  );
};
export default RegulationAlert;
